function mapObjectToArray(objData, map) {
  return Object.keys(map).reduce((acc, key) => {
    if (objData[key] === true) {
      return [...acc, { ...map[key] }];
    }
    return acc;
  }, []);
}

export default mapObjectToArray;
